import React from 'react'

const SorrySvg = ({ width, height }) => {
  return (
    <svg
      id='sad-svgrepo-com'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 77.541 77.541'
    >
      <path
        id='Path_1684'
        data-name='Path 1684'
        d='M38.77,0a38.77,38.77,0,1,0,38.77,38.77A38.815,38.815,0,0,0,38.77,0Zm0,73.35A34.573,34.573,0,1,1,73.35,38.77,34.469,34.469,0,0,1,38.77,73.35Z'
        fill='#a8a8a8'
      />
      <path
        id='Path_1685'
        data-name='Path 1685'
        d='M98.461,174.634a19.926,19.926,0,0,1,11.631,7.28l3.309-2.573a24.1,24.1,0,0,0-38.075,0l3.309,2.573A20.065,20.065,0,0,1,98.461,174.634Z'
        transform='translate(-55.593 -125.487)'
        fill='#a8a8a8'
      />
      <circle
        id='Ellipse_150'
        data-name='Ellipse 150'
        cx='4.191'
        cy='4.191'
        r='4.191'
        transform='translate(21.656 25.934)'
        fill='#a8a8a8'
      />
      <circle
        id='Ellipse_151'
        data-name='Ellipse 151'
        cx='4.191'
        cy='4.191'
        r='4.191'
        transform='translate(47.59 25.934)'
        fill='#a8a8a8'
      />
    </svg>
  )
}

export default SorrySvg
